import * as React from "react"
import styled from "styled-components"
import Box from "../../lib/ui/ui-box"
import InstagramLogo from "../instagram"
import TwitterLogo from "../twitter"

const LOGO = "/images/logo.svg"

const NavWrapper = styled(Box)`
  justify-content: space-between;
  align-items: center;
  height: 32px;
  margin: 32px 140px 0;
  @media (max-width: 1300px) {
    margin: 32px 64px 0;
  }
  @media (max-width: 600px) {
    margin: 32px 24px;
  }
`

const LogoWrapper = styled(Box)`
  max-width: 148px;
`

const IconsWrapper = styled(Box)``

const StyledLogo = styled.img`
  width: 100%;
  height: 100%;
`

const NavBar = () => {
  return (
    <NavWrapper>
      <LogoWrapper>
        <StyledLogo src={LOGO} alt="logo" />
      </LogoWrapper>
      <IconsWrapper>
        <a href="https://www.instagram.com/joinokdog/" target="_blank">
          <InstagramLogo />
        </a>
        <a href="https://twitter.com/joinokdog" target="_blank">
          <TwitterLogo />
        </a>
      </IconsWrapper>
    </NavWrapper>
  )
}

export default NavBar



// WEBPACK FOOTER //
// ./src/components/navigation/nav-bar.component.tsx